import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchBookingPayments } from '@/renderer/services/accommodationService';

export function useBookingPayments(bookingId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.bookingPayments(bookingId ?? ''),
    queryFn: () => fetchBookingPayments(bookingId!),
    enabled: !!bookingId,
  });
}
